export default {
  ownerByEntity: {},
}
